import Box from 'components/Box';
import Dropdown from 'components/Input/dropdown/Dropdown';
import { InputContainer } from '../styles';
import React from 'react';
import styled from 'styled-components/macro';
import utils from 'utils';
import { OptionsFiltersPrefererence } from 'models/userReportSettings';
import { useSelector } from 'react-redux';
import selectors from 'state/selectors';
import { InputLabel } from 'routes/Configurator/styles';

const InputContainerStyled = styled(InputContainer)`
  justify-content: center;

`;

interface Props {
  options: OptionsFiltersPrefererence[];
  setOptions: (option: { value: number; label: string }) => void;
  disabled?: boolean;
}

const SelectFilterPreference = (props: Props) => {
  const { options, setOptions, disabled } = props;

  const optionsList = options.map((option) => {
    return {
      value: option.idUserReportSetting,
      label: option.settingType,
    };
  });
  const t = utils.intl.useTranslator();
  const selectedFilterPreference = useSelector(selectors.userReportSettings.getSelectedFilterPreference);

  const closeMenuOnScroll = (event: any) => {
    if (event.target instanceof Document) {
      const activeElement = event.target.activeElement;
      if (activeElement?.id?.includes('react-select')) return false;
      return true;
    }
    if (event.target instanceof HTMLElement) {
      if (event.target?.className?.includes('MenuList') || event.target.parentElement?.className?.includes('menu')) {
        return false;
      }
      return true;
    }
    return true;
  };

  return (
    <Box title={t('select-preference-filters')}>
      <div>
        <InputContainerStyled padding='0px'>
          <InputLabel>{t('report-label-folder')}</InputLabel>
          <Dropdown
            id="report-label-folder"
            name="folder"
            value={optionsList.find((el) => el.value === selectedFilterPreference?.idUserReportSetting)}
            options={optionsList}
            onChange={setOptions}
            closeMenuOnScroll={closeMenuOnScroll}
            isClearable
            disabled={disabled}
            width="200px"
          />
        </InputContainerStyled>
      </div>
    </Box>
  );
};

export default SelectFilterPreference;
